export const MAIN_BANNER_CATEGORY = 'edu-karier';
export const COURSE_TYPE = {
  luring: 'Tatap Muka',
  webinar: 'Webinar',
  bauran_luring: 'Bauran Luring',
  bauran_daring: 'Bauran Daring',
  video_conference: 'Video Conference',
  self_paced: 'Pembelajaran Mandiri',
};
export const TNC_CHECKBOX_COPY = {
  webinar: 'Saya akan datang ke sesi webinar dan menyetujui',
  luring: 'Saya akan datang ke lokasi kelas tatap muka dan menyetujui',
};
export const TNC_CHECKBOX_FALLBACK = 'Saya akan mengikuti kelas dan menyetujui';

export const generateMetaConfig = (meta) => {
  const metaProperty = {
    'og:title': meta.title,
    'og:description': meta.description,
    'og:image': meta.image,
    'og:url': meta.url,
    'og:type': 'website',
    'og:site_name': 'Bukalapak',
  };

  const metaName = {
    description: meta.description,
    'twitter:title': meta.title,
    'twitter:description': meta.description,
    'twitter:image': meta.image,
    'twitter:card': 'summary_large_image',
    'twitter:content': '@bukalapak',
    'twitter:creator': '@bukalapak',
    'twitter:site': '@bukalapak',
  };

  const metaRel = {
    alternate: `android-app://com.bukalapak.android/${meta.alternate}`,
    canonical: meta.desktop,
  };

  document.title = meta.title;
  Object.keys(metaProperty).forEach((key) => {
    const metaTag = document.querySelector(`meta[property="${key}"]`);
    metaTag?.setAttribute('content', metaProperty[key]);
  });

  Object.keys(metaName).forEach((key) => {
    const metaTag = document.querySelector(`meta[name="${key}"]`);
    metaTag?.setAttribute('content', metaName[key]);
  });

  Object.keys(metaRel).forEach((key) => {
    const metaTag = document.querySelector(`link[rel="${key}"]`);
    metaTag?.setAttribute('href', metaRel[key]);
  });
};
